import { render, staticRenderFns } from "./MenuPanelGroup.vue?vue&type=template&id=2c7bd3cd&"
import script from "./MenuPanelGroup.vue?vue&type=script&lang=js&"
export * from "./MenuPanelGroup.vue?vue&type=script&lang=js&"
import style0 from "./MenuPanelGroup.vue?vue&type=style&index=0&id=2c7bd3cd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports